import { createContext, useContext } from 'react'
import type { LoginAutenticado, UserToken } from '@/types/auth'
import type { Acao } from '@/utility/permissions'

export interface AuthContextValue {
  user: UserToken | null
  isAuthenticated: boolean
  isAdmin: boolean
  can: (acao: Acao) => boolean
  signIn: (login: LoginAutenticado) => void
  signOut: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth precisa estar dentro de AuthProvider.')
  return context
}
